// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__22M3x","content":"Alert_content__LWMT1","info":"Alert_info__3S3VJ","icon":"Alert_icon__zIltg","success":"Alert_success__1VMSW","error":"Alert_error__AJTKN"};